import { render } from "./about.vue?vue&type=template&id=7d394328&scoped=true"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"

import "./about.vue?vue&type=style&index=0&id=7d394328&lang=css"
import "./about.vue?vue&type=style&index=1&id=7d394328&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d394328"]])

export default __exports__